// @ts-check
/* eslint-env browser */

import { reactiveStore } from '../reactive-store.js'

export class TileSwitcher extends HTMLElement {
  connectedCallback () {
    this.#setupClickHandlers()

    // Sync radio buttons with reactiveStore.tileType
    reactiveStore.tileType.subscribe((/** @type string */ tileType) => {
      /** @type {HTMLInputElement | null} */
      const button = this.querySelector(`input[value="${tileType}"]`)
      if (button) {
        button.checked = true
      }
    })
  }

  /**
   * Updates reactiveStore.tileType when radio buttons are clicked
   */
  #setupClickHandlers () {
    /** @type {NodeListOf<HTMLInputElement>} */
    const buttons = this.querySelectorAll('input[type="radio"]')
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        reactiveStore.tileType.set(button.value)
      })
    })
  }
}

customElements.define('tile-switcher', TileSwitcher)
